import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { CheckCircle2, ArrowLeft } from 'lucide-react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await axios.post(`${API}/auth/forgot-password`, { email: email.trim().toLowerCase() });
      setSent(true);
    } catch (err) {
      setError(err.response?.data?.detail || 'Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4">
      <Card className="w-full max-w-md shadow-xl">
        <CardHeader className="text-center">
          <img
            src="https://customer-assets.emergentagent.com/job_20414c3a-9623-4d12-8f24-8780a5aa64c8/artifacts/y936iv32_%3D2_transparent_logo.png"
            alt="Equaltoo"
            className="h-20 w-auto mx-auto mb-4"
          />
          {sent ? (
            <>
              <div className="flex justify-center mb-2">
                <CheckCircle2 className="w-12 h-12 text-green-500" />
              </div>
              <CardTitle className="text-2xl text-gray-900">Check your inbox</CardTitle>
              <CardDescription className="text-base mt-1">
                If <strong>{email}</strong> is registered, you'll receive a reset link within a few minutes.
                Check your spam folder if you don't see it.
              </CardDescription>
            </>
          ) : (
            <>
              <CardTitle className="text-2xl text-gray-900">Forgot your password?</CardTitle>
              <CardDescription className="text-base mt-1">
                Enter your email and we'll send you a link to set a new password.
              </CardDescription>
            </>
          )}
        </CardHeader>

        {!sent && (
          <CardContent>
            <form onSubmit={handleSubmit} className="space-y-5">
              <div>
                <Label htmlFor="email">Email Address</Label>
                <Input
                  id="email"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  placeholder="your.email@example.com"
                  className="mt-2"
                  data-testid="forgot-email-input"
                />
              </div>

              {error && (
                <p className="text-sm text-red-600" data-testid="forgot-error">{error}</p>
              )}

              <Button
                type="submit"
                className="w-full bg-[#e74c3c] hover:bg-[#c0392b]"
                size="lg"
                disabled={loading}
                data-testid="forgot-submit-btn"
              >
                {loading ? 'Sending…' : 'Send Reset Link'}
              </Button>
            </form>
          </CardContent>
        )}

        <div className="px-6 pb-6 text-center">
          <Link
            to="/login"
            className="inline-flex items-center gap-1.5 text-sm text-[#666] hover:text-[#003366] transition-colors"
            data-testid="back-to-login-link"
          >
            <ArrowLeft className="w-4 h-4" /> Back to login
          </Link>
        </div>
      </Card>
    </div>
  );
};

export default ForgotPassword;
